import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      gcTime: 5 * 60 * 1000,
      // Don't retry HTTP errors — only network failures, up to twice.
      retry: (failureCount, error: any) => {
        if (error?.statusCode) return false;
        return failureCount < 2;
      },
      refetchOnMount: 'always',
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
});

export const queryKeys = {
  auth: { me: () => ['auth', 'me'] as const },
  dashboard: (from: string, to: string) => ['dashboard', from, to] as const,
  company: () => ['company-profile'] as const,
  users: () => ['users'] as const,
  clients: { all: () => ['clients'] as const },
  billingConfigs: {
    all: () => ['billing-configs'] as const,
    overview: () => ['billing-configs', 'overview'] as const,
    active: (clientId: number) => ['billing-configs', 'active', clientId] as const,
    history: (clientId: number) => ['billing-configs', 'history', clientId] as const,
  },
  billing: {
    all: () => ['billing'] as const,
    invoices: (filters?: object) => ['billing', 'invoices', filters ?? {}] as const,
    invoice: (id: number) => ['billing', 'invoice', id] as const,
  },
  expenses: {
    all: () => ['expenses'] as const,
    list: (filters?: object) => ['expenses', 'list', filters ?? {}] as const,
  },
  categories: () => ['expense-categories'] as const,
  recurring: () => ['recurring-expenses'] as const,
  employees: { all: () => ['employees'] as const, payroll: (month: string) => ['employees', 'payroll', month] as const },
  capital: () => ['capital'] as const,
  reports: { pnl: (fy: string) => ['reports', 'pnl', fy] as const },
};
